
import React, { useState } from "react";
import {
    Box,
    Button,
    Stack,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    IconButton,
    Tooltip
} from "@mui/material";

import dayjs from "dayjs";
import PeriodicReportTable from "../../Components/Tables/PeriodicReportTable";

const PeriodicReportsScheduler = () => {


    const currentYear = dayjs().year();
    const currentMonth = dayjs().format("MMM");
    const today = dayjs();

    const lastFiveYears = Array.from({ length: 5 }, (_, i) => currentYear - i);
    const months = Array.from({ length: 12 }, (_, i) => dayjs().month(i).format("MMM"));

    const [year, setYear] = useState(currentYear);
    const [month, setMonth] = useState(currentMonth);
    const [status, setStatus] = useState("all")
    const [bulkActions, setBulkActions] = useState("send")
    const [frequency, setFrequency] = useState("weekly")
    const [quarterly, setQuaterly] = useState("january_march")
    const [halfYearly, setHalfYearly] = useState("january_june")

    const frequencyOpt = [
        { value: "weekly", label: "Weekly" },
        { value: "semi_monthly", label: "Semi - Monthly" },
        { value: "monthly", label: "Monthly" },
        { value: "quarterly", label: "Quarterly" },
        { value: "half_yearly", label: "Half Yearly" },
        { value: "yearly", label: "Yearly" },
    ];

    const getWeeks = () => {

        let start = dayjs(`${year}-${month}-01`, "YYYY-MMM-DD");
        start = start.day() === 0 ? start : start.subtract(start.day(), "day");

        let weeks = [];

        while (weeks.length < 5) {
            let weekStart = start;
            let weekEnd = weekStart.add(6, "day");

            weeks.push(`${weekStart.format("DD MMM, YYYY")} - ${weekEnd.format("DD MMM, YYYY")}`);

            start = weekEnd.add(1, "day");
        }

        return weeks;
    };

    const weeks = getWeeks();

    const currentWeek = weeks.find(week => {
        const [start, end] = week.split(" - ").map(date => dayjs(date, "DD MMM, YYYY"));
        return today >= start && today <= end;
    }) || weeks[0];

    const [selectedWeek, setSelectedWeek] = useState(currentWeek || weeks[0] || "");

    const getSemiMonthlyPeriods = (year, month) => {
        const startOfMonth = dayjs(`${year}-${month}-01`, "YYYY-MMM-DD");
        const endOfMonth = startOfMonth.endOf("month").date();

        return [
            `01 ${startOfMonth.format("MMM, YYYY")} - 15 ${startOfMonth.format("MMM, YYYY")}`,
            `16 ${startOfMonth.format("MMM, YYYY")} - ${endOfMonth} ${startOfMonth.format("MMM, YYYY")}`,
        ];
    };

    const semiMonthlyOptions = getSemiMonthlyPeriods(year, month);
    const [selectedSemiMonth, setSelectedSemiMonth] = useState(semiMonthlyOptions[0]);


    return (
        <Box height="calc(100vh - 86px)" width="100%" >
            <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                gap={5}

            >
                <Stack direction="row" gap={2}>
                    <FormControl sx={{ minWidth: 150, maxWidth: 150 }}>
                        <InputLabel id="bulk-action-label">Bulk Action</InputLabel>
                        <Select
                            size="small"
                            value={bulkActions}
                            label="Bulk Action"
                            onChange={(e) => setBulkActions(e.target.value)}
                        >
                            <MenuItem value="send">Send</MenuItem>
                            <MenuItem value="schedule">Schedule</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl sx={{ minWidth: 150, maxWidth: 280, }}>
                        <InputLabel id="bulk-action-label">Report Frequency</InputLabel>
                        <Select
                            size="small"
                            label="Report Frequency"
                            value={frequency}
                            onChange={(e) => setFrequency(e.target.value)}
                        >
                            {frequencyOpt.map(({ value, label }) => (
                                <MenuItem key={value} value={value}>{label}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                </Stack>

                <Stack direction="row" gap={2}>
                    <FormControl sx={{ minWidth: 120, maxWidth: 280, }}>
                        <InputLabel id="bulk-action-label">Status</InputLabel>
                        <Select
                            size="small"
                            label="Status"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <MenuItem value="all">All</MenuItem>
                            <MenuItem value="sent">Sent</MenuItem>
                            <MenuItem value="unsent">Unsent</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl sx={{ minWidth: 100, maxWidth: 280, }}>
                        <InputLabel id="bulk-action-label">Year</InputLabel>
                        <Select
                            size="small"
                            label="Year"
                            value={year}
                            onChange={(e) => setYear(e.target.value)}

                        >
                            {lastFiveYears.map((year) => (
                                <MenuItem key={year} value={year}>
                                    {year}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {
                        frequency !== "half_yearly" && frequency !== "yearly" && (
                            <FormControl sx={{ minWidth: 100, maxWidth: 280 }}>
                                <InputLabel id="bulk-action-label">Month</InputLabel>
                                <Select
                                    label="Month"
                                    size="small"
                                    value={month}
                                    onChange={(e) => setMonth(e.target.value)}
                                >
                                    {months.map((month, index) => (
                                        <MenuItem key={index} value={month}>
                                            {month}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        )

                    }
                    {
                        frequency === "weekly" && (
                            <FormControl sx={{ minWidth: 220, maxWidth: 350 }}>
                                <InputLabel>Week</InputLabel>
                                <Select size="small" label="Week"
                                    value={selectedWeek} onChange={(e) => setSelectedWeek(e.target.value)}
                                >
                                    {getWeeks().map((week, index) => (
                                        <MenuItem key={index} value={week}>{week}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )

                    }
                    {
                        frequency === "semi_monthly" && (

                            <FormControl sx={{ minWidth: 200, maxWidth: 300 }}>
                                <InputLabel>Semi Month</InputLabel>
                                <Select
                                    size="small"
                                    label="Semi Month"
                                    value={selectedSemiMonth}
                                    onChange={(e) => setSelectedSemiMonth(e.target.value)}
                                >
                                    {semiMonthlyOptions.map((period, index) => (
                                        <MenuItem key={index} value={period}>
                                            {period}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        )
                    }
                    {
                        frequency === "quarterly" && (

                            <FormControl sx={{ minWidth: 200, maxWidth: 300 }}>
                                <InputLabel>Semi Month</InputLabel>
                                <Select
                                    size="small"
                                    label="Semi Month"
                                    value={quarterly}
                                    onChange={(e) => setQuaterly(e.target.value)}
                                >
                                    <MenuItem value="january_march">January - March</MenuItem>
                                    <MenuItem value="april_june">April - June</MenuItem>
                                    <MenuItem value="july_september">July - September</MenuItem>
                                    <MenuItem value="october_december">October - December</MenuItem>
                                </Select>
                            </FormControl>

                        )
                    }
                    {
                        frequency === "half_yearly" && (

                            <FormControl sx={{ minWidth: 200, maxWidth: 300 }}>
                                <InputLabel>Half Yearly</InputLabel>
                                <Select
                                    size="small"
                                    label="Half Yearly"
                                    value={halfYearly}
                                    onChange={(e) => setHalfYearly(e.target.value)}
                                >
                                    <MenuItem value="january_june">January - June</MenuItem>
                                    <MenuItem value="july_december">July - December</MenuItem>
                                </Select>
                            </FormControl>

                        )
                    }

                </Stack>


            </Stack>
            
            <Box 
                // border={"1px solid red"}
                height={"calc(100vh - 130px)"}
                mt={2}
            >
                <PeriodicReportTable />

            </Box>
        </Box>
    );

}

export default PeriodicReportsScheduler;